import { extractLibraryFileId } from "../logo/utils/get_library_file_id";

export default class LibraryLogoUploadSaver {
  static async save(cropper, thumbImgTarget, titleTarget, application) {
    let logoData;
    const isCropped = cropper.hasChanged();

    if (isCropped) {
      const canvas = cropper.get_cropped_canvas();
      const mimeType = cropper.get_image_mime_type();
      logoData = await new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            window.blobs = { ...window.blobs, logo: blob };
            resolve({ url, name: titleTarget.innerText });
          } else {
            reject("Blob creation failed");
          }
        }, mimeType);
      });
    } else {
      const selectedFromLibrary = thumbImgTarget.getAttribute('data-selected-from-library') === 'true';
      if (!selectedFromLibrary && window.blobs?.logo) return;

      let url = thumbImgTarget.getAttribute('data-original-url');
      let smallUrl = thumbImgTarget.getAttribute('data-small-url');
      const id = extractLibraryFileId(url);
      logoData = { id, url, smallUrl, name: titleTarget.innerText };
    }

    const brandElement = document.querySelector(
      "[data-controller='site-builder--brand']"
    );
    if (brandElement) {
      const brandController = application.getControllerForElementAndIdentifier(
        brandElement,
        "site-builder--brand"
      );
      if (brandController) {
        brandController.updateLogo(logoData);
      } else {
        console.error("BrandController instance not found");
      }
    } else {
      console.error(
        "Element with 'data-controller=site-builder--brand' not found"
      );
    }
  }
}
